import { Component, Input, SimpleChanges } from '@angular/core';
import { GameTopPerformer, IHSelectedMetric } from '../../../../models/games-parameter.model';
import { GamesParameterHistoryService } from '../../../../services/games-parameter-history.service';
import { GameType } from '../../../../models/games.model';
import moment from 'moment';

@Component({
  selector: 'cv-health-report-top-performers',
  templateUrl: './health-report-top-performers.component.html',
  styleUrl: './health-report-top-performers.component.scss'
})
export class HealthReportTopPerformersComponent {
    @Input() game = null;
    @Input() endDate: string = null;
    @Input() isLoading: boolean = false;

    gameTypeEnum = GameType;
    topPerformers: GameTopPerformer[];
    metricList: IHSelectedMetric[] = [];
    gameMetric: IHSelectedMetric;
    qualifier: IHSelectedMetric;

    constructor(private gamesParameterHistoryService: GamesParameterHistoryService) { }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.endDate?.currentValue || changes.game?.currentValue) {
            this.game = changes.game?.currentValue || this.game;
            this.endDate = changes.endDate?.currentValue?.split('T')[0] || this.endDate;
            this.cleanVariables();
        }
        if (changes.isLoading && !this.isLoading) {
            this.getMetrics();
            this.getTopPerformers();
        }
    }

    onChangeMetric() {
        this.topPerformers = [];
        this.getTopPerformers();
    }

    cleanVariables() {
        this.topPerformers = [];
        this.metricList = [];
        this.gameMetric = null;
        this.qualifier = null;
    }

    getTopPerformers() {
        this.isLoading = true;
        let startDate = this.getStartDateByEndDate(this.endDate, this.game.Intervals);

        this.gamesParameterHistoryService.getTopPerformers(this.game.RuleID, startDate, this.endDate, this.gameMetric.MetricID, this.qualifier?.MetricID).then((result) => {
            this.topPerformers = result;
            this.isLoading = false;
        });
    }

    getMetrics() {
        const metrics = this.gamesParameterHistoryService.getMetrics(this.game.RuleID, this.endDate);

        if (this.game?.GameType == GameType.Raffle) {
            this.gameMetric = metrics.length > 0 ? metrics[0] : null;
            this.qualifier = metrics.length > 0 ? metrics[1] : null;
        }
        else if (this.game?.GameType != GameType.Connect3 && this.game?.GameType != GameType.Blackout) {
            this.gameMetric = metrics.length > 0 ? metrics.find(x => !x.IsQualifier) : null;
            this.qualifier = metrics.find(x => x.IsQualifier);
        } else {
            this.metricList = metrics.filter(x => !x.IsQualifier);
            this.gameMetric = this.metricList[0];
            this.qualifier = metrics.find(x => x.IsQualifier);
        }
    }

    getStartDateByEndDate(date: string, intervals: object[]): string | undefined {
        const interval = intervals.find(interval => {
            const endDate = moment((interval as any).EndDate).format('YYYY-MM-DD');
            return endDate == date;
        });

        return interval ? moment((interval as any).StartDate).format('YYYY-MM-DD') : undefined;
    }
}
